// SETTINGS
export const LANGUAGES = 'LANGUAGES'
export const ACTIVE_LANGUAGE = 'ACTIVE_LANGUAGE'
export const DEFAULT_LANGUAGE = 'DEFAULT_LANGUAGE'

// Page
export const ALL_PAGES = 'ALL_PAGES'
export const ACTIVE_PAGE = 'ACTIVE_PAGE'
export const GET_ALL_PAGES = 'GEL_ALL_PAGES'
export const ADD_PAGE = 'ADD_PAGE'
export const REMOVE_PAGE = 'REMOVE_PAGE'
export const UPDATE_PAGE_URL = 'UPDATE_PAGE_URL'
export const UPDATE_PAGE = 'UPDATE_PAGE'
export const IS_LOADING_PAGES = 'IS_LOADING_PAGES'

// Media
export const ALL_MEDIA_ITEMS = 'ALL_MEDIA_ITEMS'
export const GET_ALL_MEDIA_ITEMS = 'GEL_ALL_MEDIA_ITEMS'
export const ADD_MEDIA = 'ADD_MEDIA'
export const REMOVE_MEDIA = 'REMOVE_MEDIA'
export const UPDATE_MEDIA_URL = 'UPDATE_MEDIA_URL'
export const IS_LOADING_MEDIA_ITEMS = 'IS_LOADING_MEDIA_ITEMS'

// Categories
export const ALL_CATEGORIES = 'ALL_CATEGORIES'
export const ALL_CATEGORIES_TREE = 'ALL_CATEGORIES_TREE'
export const ACTIVE_CATEGORY = 'ACTIVE_CATEGORY'
export const GET_ALL_CATEGORIES = 'GEL_ALL_CATEGORIES'
export const ADD_CATEGORY = 'ADD_CATEGORY'
export const UPDATE_CATEGORY = 'UPDATE_CATEGORY'
export const REMOVE_CATEGORY = 'REMOVE_CATEGORY'
export const UPDATE_CATEGORY_URL = 'UPDATE_CATEGORY_URL'
export const IS_LOADING_CATEGORIES = 'IS_LOADING_CATEGORIES'

// Navigations
export const ALL_NAVIGATIONS = 'ALL_NAVIGATIONS'
export const ACTIVE_NAVIGATION = 'ACTIVE_NAVIGATION'
export const GET_ALL_NAVIGATIONS = 'GEL_ALL_NAVIGATIONS'
export const ADD_NAVIGATION = 'ADD_NAVIGATION'
export const REMOVE_NAVIGATION = 'REMOVE_NAVIGATION'
export const IS_LOADING_NAVIGATIONS = 'IS_LOADING_NAVIGATIONS'

// Type
export const ALL_TYPES = 'ALL_TYPES'
export const ACTIVE_TYPE = 'ACTIVE_TYPE'
export const GET_ALL_TYPES = 'GEL_ALL_TYPES'
export const ADD_TYPE = 'ADD_TYPE'
export const REMOVE_TYPE = 'REMOVE_TYPE'
export const IS_LOADING_TYPES = 'IS_LOADING_TYPE'

// Slider
export const ALL_SLIDERS = 'ALL_SLIDERS'
export const ACTIVE_SLIDER = 'ACTIVE_SLIDER'
export const GET_ALL_SLIDERS = 'GEL_ALL_SLIDERS'
export const ADD_SLIDER = 'ADD_SLIDER'
export const REMOVE_SLIDER = 'REMOVE_SLIDER'
export const IS_LOADING_SLIDERS = 'IS_LOADING_SLIDERS'

// User
export const ALL_USERS = 'ALL_USERS'
export const ACTIVE_USER = 'ACTIVE_USER'
export const GET_ALL_USERS = 'GEL_ALL_USERS'
export const ADD_USER = 'ADD_USER'
export const REMOVE_USER = 'REMOVE_USER'
export const UPDATE_USER_URL = 'UPDATE_USER_URL'
export const IS_LOADING_USERS = 'IS_LOADING_USERS'



// WEBPACK FOOTER //
// ./src/store/types.js